var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('div',{staticClass:"nav-group"},[_c('router-link',{staticClass:"title-link",attrs:{"to":"/sessions"}},[_c('h1',{staticClass:"brand"},[_vm._v("Superset")])])],1),_c('div',{staticClass:"nav-group"},[(!_vm.hideLogin)?_c('login-container'):_vm._e()],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f757f4f6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/Navbar.vue
// module id = null
// module chunks = 